export default class ButtonSpam {

    constructor(){
        this.buttons={};
        this.timeout = 1000;
    };

    isSpam(button_id, disable = true,timeout=1000){
        let bs = this;
        this.timeout = timeout;
        //check if an element doesn't exist and create one if not
        if(!bs.buttons[button_id]){
            bs.buttons[button_id]={
                btnClicks:0,
                buttonClickTimeout:0
            };
        }

        bs.incrementClick(button_id);
        // console.error(bs.buttons[button_id].btnClicks);
        if(bs.buttons[button_id].btnClicks > 1){
            return true;
        }else{
            if(disable){
                $(`#${button_id}`).attr('disabled', true);
            }
            bs.resetButtonTimeout(button_id, disable);
            return false;
        }
    }

    incrementClick(button_id){
        let bs = this;
        //increments the btnClick for the given button ID
        bs.buttons[button_id].btnClicks++;
    }

    resetButtonTimeout(button_id, disable){
        let bs = this;
        clearTimeout(bs.buttons[button_id].buttonClickTimeout)
        //resets the object data after 1.5 sec
        bs.buttons[button_id].buttonClickTimeout = setTimeout(() => {
            bs.buttons[button_id].btnClicks = 0;
            if(disable){
                $(`#${button_id}`).attr('disabled', false);
            }
        }, bs.timeout);
    }

}
